import ContentLayout from '@/layouts/content-layout'
import FeedFormView from '@/sections/feeds/view/feed-form-view'

export default function FeedForm() {
  return (
    <ContentLayout title="ฟีด" backButton>
      <FeedFormView />
    </ContentLayout>
  )
}
